'use client';

import React from 'react';
import { Paper, Title, Text } from '@mantine/core';

interface EmailTemplateEditorProps {
  template: any;
  onChange: (template: any) => void;
  testData?: any;
}

export function EmailTemplateEditor({ template, onChange, testData }: EmailTemplateEditorProps) {
  return (
    <Paper shadow="sm" radius="md" p="lg">
      <Title order={4}>Email Template Editor</Title>
      <Text c="dimmed" size="sm">Template editor coming soon</Text>
    </Paper>
  );
}